// ĐỢT B (08/10/2026) — CÁC Ô TUỲ CHỌN THEO BƯỚC trên sơ đồ (kịch bản seeding 7 ngày của người dùng): hạn mức mỗi ngày của bước, tỉ lệ nhắc sản phẩm riêng + "bắt buộc có tên",
// xem/đọc trước khi bình luận, nghỉ ngẫu nhiên từ–đến (X / TikTok / YouTube / Reddit), lướt theo phút / số mục ngẫu nhiên / thích ngẫu nhiên.
// Cách gắn GIỐNG "Chờ giữa các lần" (cho-giua-lan.ts): tham số TUỲ CHỌN (anKhiRong) của khối + trường trong PHẦN ĐÃ HỌC của bước liên quan, giá trị điền lúc lắp ({{ts.x}});
// người dùng bỏ trống → lúc lắp BỎ trường (locTuyChonBuoc) → YAML / bundle / hash y như trước (kịch bản cũ không phải chạy thử lại). Bundle có trường mới tự khai can_plugin
// (phien-ban-plugin.ts PLUGIN_CAN_DOT_B). Module THUẦN, không I/O — thư viện khối (khoi-thu-vien.ts), lắp (tu-dung.ts), test dùng chung.
import type { KhoiMau, KhoiThamSo, BienTheTuTim } from "./tu-dung";
import { loaiDemCuaBuoc } from "./han-muc-ngay";

// ---------------------------------------------------------------- đọc cây bước của một đoạn yamlSteps ----------------------------------------------------------------
export interface BuocYaml { id: string; cha: string[]; tc: Record<string, string> }
/** Mọi bước (mọi cấp) của yamlSteps theo thứ tự: id, chuỗi id bước cha (ngoài → trong), các khoá cấp một của bước (ledger, into, risk, for_each, wait…; khoá có khối con → ""). */
export function quetBuocYaml(y: string): BuocYaml[] {
  const ra: BuocYaml[] = [];
  const ngan: { thut: number; b: BuocYaml }[] = [];
  for (const dong of y.split("\n")) {
    const m = /^(\s*)- id:\s*([A-Za-z0-9_]+)\s*$/.exec(dong);
    if (m) {
      const thut = m[1]!.length;
      while (ngan.length && ngan[ngan.length - 1]!.thut >= thut) ngan.pop();
      const b: BuocYaml = { id: m[2]!, cha: ngan.map((x) => x.b.id), tc: {} };
      ra.push(b);
      ngan.push({ thut, b });
      continue;
    }
    const top = ngan[ngan.length - 1];
    if (!top) continue;
    const k = /^(\s*)([A-Za-z_][A-Za-z0-9_]*):\s*(.*)$/.exec(dong);
    if (k && k[1]!.length === top.thut + 2) top.b.tc[k[2]!] = k[3]!.trim().replace(/^"(.*)"$/, "$1");
  }
  return ra;
}

/** Phần đã học của một bước (bước con: learned[cha0].con[cha1]…con[id]). Không có → undefined. */
export function hocCua(learned: Record<string, unknown>, cha: readonly string[], id: string): Record<string, unknown> | undefined {
  let o: Record<string, unknown> | undefined = learned;
  for (const c of cha) { const x = o?.[c] as { con?: Record<string, unknown> } | undefined; o = x?.con; if (!o) return undefined; }
  const v = o?.[id];
  return v && typeof v === "object" && !Array.isArray(v) ? (v as Record<string, unknown>) : undefined;
}
/** Bản mới của learned với `them` gộp vào phần đã học của bước (tạo đường con nếu thiếu). Không sửa đầu vào. */
export function ganHoc(learned: Record<string, unknown>, cha: readonly string[], id: string, them: Record<string, unknown>): Record<string, unknown> {
  if (!cha.length) return { ...learned, [id]: { ...((learned[id] as Record<string, unknown> | undefined) ?? {}), ...them } };
  const [dau, ...con] = cha;
  const nut = (learned[dau!] as Record<string, unknown> | undefined) ?? {};
  const conCu = (nut.con as Record<string, unknown> | undefined) ?? {};
  return { ...learned, [dau!]: { ...nut, con: ganHoc(conCu, con, id, them) } };
}

/** Áp `f` cho bản chính của khối VÀ biến thể tự tìm (nếu có) — mỗi phần một cặp yamlSteps/learned riêng. */
function moiPhan(k: KhoiMau, f: (yaml: string, learned: Record<string, unknown>) => Record<string, unknown> | null): KhoiMau | null {
  const chinh = f(k.yamlSteps, k.learned);
  let tuTim: BienTheTuTim | undefined = k.tuTim;
  let doiTuTim = false;
  if (k.tuTim) {
    const l = f(`${k.tuTim.yamlTim}\n${k.tuTim.yamlSteps}`, k.tuTim.learned);
    if (l) { tuTim = { ...k.tuTim, learned: l }; doiTuTim = true; }
  }
  if (!chinh && !doiTuTim) return null;
  return { ...k, learned: chinh ?? k.learned, ...(tuTim ? { tuTim } : {}) };
}

// ---------------------------------------------------------------- MỤC 1: hạn mức mỗi ngày của bước ----------------------------------------------------------------
export const TS_TOI_DA_NGAY = "toi_da_ngay";
export const THAM_SO_TOI_DA_NGAY: KhoiThamSo = {
  ten: TS_TOI_DA_NGAY, kieu: "so", anKhiRong: true, min: 0, max: 365,
  moTa: "tối đa bao nhiêu lần làm việc này MỖI NGÀY cho một nick trên mạng này (đếm chung với các bước cùng loại: bình luận / trả lời / trích dẫn / tham gia nhóm…); hết lượt thì bỏ phần còn lại của bước, các bước sau vẫn chạy; bỏ trống = theo Cài đặt của bot",
};
/** Bước ĐẾM ngày của một phần (yaml + learned): bước có loại đếm (khai dem_ngay trong phần đã học, hoặc suy từ sổ cái). */
export function buocDemNgay(yaml: string, learned: Record<string, unknown>): BuocYaml[] {
  return quetBuocYaml(yaml).filter((b) => loaiDemCuaBuoc({ ledger: b.tc.ledger, id: b.id, risk: b.tc.risk, ...(hocCua(learned, b.cha, b.id)?.dem_ngay !== undefined ? { dem_ngay: hocCua(learned, b.cha, b.id)!.dem_ngay } : {}) }) !== null);
}
/** + ô "Tối đa mỗi ngày" cho khối có bước đếm ngày (bản chính hoặc biến thể tự tìm); mỗi bước đếm mang han_ngay = {{ts.toi_da_ngay}}. */
export function themToiDaNgay(k: KhoiMau): KhoiMau {
  if (k.thamSo.some((t) => t.ten === TS_TOI_DA_NGAY)) return k;
  const moi = moiPhan(k, (yaml, learned) => {
    const ds = buocDemNgay(yaml, learned);
    if (!ds.length) return null;
    let l = learned;
    for (const b of ds) l = ganHoc(l, b.cha, b.id, { han_ngay: `{{ts.${TS_TOI_DA_NGAY}}}` });
    return l;
  });
  return moi ? { ...moi, thamSo: [...k.thamSo, THAM_SO_TOI_DA_NGAY] } : k;
}

// ---------------------------------------------------------------- MỤC 2: tỉ lệ nhắc sản phẩm của bước + bắt buộc có tên ----------------------------------------------------------------
export const TS_TI_LE_NHAC = "ti_le_nhac";
export const TS_BAT_BUOC_TEN = "bat_buoc_ten";
export const THAM_SO_NHAC_SP: KhoiThamSo[] = [
  { ten: TS_TI_LE_NHAC, kieu: "so", anKhiRong: true, min: 0, max: 100, moTa: "phần trăm câu bình luận/trả lời CỦA BƯỚC NÀY được nhắc tên sản phẩm (0 = không bao giờ, 100 = mọi câu); bỏ trống = theo Cài đặt của bot (mặc định 33%)" },
  { ten: TS_BAT_BUOC_TEN, kieu: "chuoi", anKhiRong: true, macDinh: "khong", luaChon: ["khong", "co"], moTa: "co = câu được bốc nhắc sản phẩm mà AI soạn lại một lần vẫn thiếu tên sản phẩm thì BỎ câu đó (không gửi); khong (mặc định) = vẫn gửi câu thiếu tên" },
];
const DICH_CAU = /(?:^|\.)(?:binh_luan|tra_loi|cau_tra_loi|trich_dan)$/;
/** Bước SOẠN câu bình luận / trả lời / trích dẫn (generate, đích là câu — giống ti-le-nhac-sp.ts laCauBinhLuanTraLoi; bài đăng của chủ nick thì không). */
export function buocSoanCau(yaml: string): BuocYaml[] {
  return quetBuocYaml(yaml).filter((b) => b.tc.generate !== undefined && typeof b.tc.into === "string" && DICH_CAU.test(b.tc.into));
}
/** + ô "Tỉ lệ nhắc sản phẩm" + "Bắt buộc có tên" cho khối có bước soạn câu; bước soạn mang nhac_sp = { ti_le, bat_buoc } (điền lúc lắp, bỏ khi trống). */
export function themNhacSp(k: KhoiMau): KhoiMau {
  if (k.thamSo.some((t) => t.ten === TS_TI_LE_NHAC)) return k;
  const moi = moiPhan(k, (yaml, learned) => {
    const ds = buocSoanCau(yaml);
    if (!ds.length) return null;
    let l = learned;
    for (const b of ds) l = ganHoc(l, b.cha, b.id, { nhac_sp: { ti_le: `{{ts.${TS_TI_LE_NHAC}}}`, bat_buoc: `{{ts.${TS_BAT_BUOC_TEN}}}` } });
    return l;
  });
  return moi ? { ...moi, thamSo: [...k.thamSo, ...THAM_SO_NHAC_SP] } : k;
}

// ---------------------------------------------------------------- MỤC 3: Nghỉ từ–đến (X / TikTok / YouTube / Reddit) ----------------------------------------------------------------
// Khối nghỉ của các mạng này chỉ có `wait: {{ts.giay_nghi}}` (một số giây). Thêm ô "Nghỉ từ / Đến (giây)" TUỲ CHỌN — cùng TÊN với khối nghỉ Facebook (tu_giay / den_giay) để
// do-thi.ts khoangNghiS (Boss giữ đồng hồ ở chỗ cắt, ≤ 6 giờ), ước lượng thời gian và AI dùng chung; giay_nghi GIỮ NGUYÊN (kịch bản cũ chạy y như trước).
export const THAM_SO_NGHI_KHOANG: KhoiThamSo[] = [
  { ten: "tu_giay", kieu: "so", anKhiRong: true, min: 5, max: 1800, moTa: "nghỉ NGẪU NHIÊN ít nhất bao nhiêu giây (điền cả hai ô từ–đến thì thay cho số giây cố định; bước Nghỉ dành cho nhánh khác tối đa 6 giờ = 21600)" },
  { ten: "den_giay", kieu: "so", anKhiRong: true, min: 5, max: 1800, moTa: "nghỉ NGẪU NHIÊN nhiều nhất bao nhiêu giây (không nhỏ hơn số giây ít nhất)" },
];
/** Khối nghỉ chỉ có giay_nghi (không có tu_giay) → + từ–đến; bước wait mang khoang_nghi (bỏ khi trống). */
export function themNghiKhoang(k: KhoiMau): KhoiMau {
  if (!k.thamSo.some((t) => t.ten === "giay_nghi") || k.thamSo.some((t) => t.ten === "tu_giay")) return k;
  const ds = quetBuocYaml(k.yamlSteps).filter((b) => b.tc.wait === "{{ts.giay_nghi}}");
  if (!ds.length) return k;
  let l = k.learned;
  for (const b of ds) l = ganHoc(l, b.cha, b.id, { khoang_nghi: { tu: "{{ts.tu_giay}}", den: "{{ts.den_giay}}" } });
  return { ...k, learned: l, thamSo: [...k.thamSo, ...THAM_SO_NGHI_KHOANG] };
}

// ---------------------------------------------------------------- MỤC 4: xem / đọc trước khi bình luận / trả lời ----------------------------------------------------------------
export const TS_XEM_TU = "xem_tu_giay";
export const TS_XEM_DEN = "xem_den_giay";
/** Khối nhận ô xem trước (bước GỬI có mở trang video / bài): TikTok / YouTube bình luận; X trả lời (đọc bài). */
export const XEM_TRUOC_THEO_KHOI: Readonly<Record<string, "xem" | "doc">> = {
  "tiktok/binh_luan": "xem", "tiktok/binh_luan_mot_bai": "xem", "youtube/binh_luan": "xem", "youtube/binh_luan_mot_bai": "xem",
  "x/tra_loi": "doc", "x/tra_loi_mot_bai": "doc", "x/binh_luan_mot_bai": "doc",
};
function thamSoXem(loai: "xem" | "doc"): KhoiThamSo[] {
  const viec = loai === "xem" ? "XEM video" : "ĐỌC bài";
  return [
    { ten: TS_XEM_TU, kieu: "so", anKhiRong: true, min: 0, max: 300, moTa: `${viec} ít nhất bao nhiêu giây (mở trang rồi chờ, NGẪU NHIÊN trong khoảng từ–đến) trước khi gõ ${loai === "xem" ? "bình luận" : "trả lời"}; bỏ trống = nhịp đọc mặc định của bot` },
    { ten: TS_XEM_DEN, kieu: "so", anKhiRong: true, min: 0, max: 300, moTa: `${viec} nhiều nhất bao nhiêu giây trước khi gõ (không nhỏ hơn "từ")` },
  ];
}
export function themXemTruoc(ma: string, k: KhoiMau): KhoiMau {
  const loai = XEM_TRUOC_THEO_KHOI[`${ma}/${k.ten}`];
  if (!loai || k.thamSo.some((t) => t.ten === TS_XEM_TU)) return k;
  const moi = moiPhan(k, (yaml, learned) => {
    const ds = buocDemNgay(yaml, learned);
    if (!ds.length) return null;
    let l = learned;
    for (const b of ds) l = ganHoc(l, b.cha, b.id, { xem_truoc: { tu: `{{ts.${TS_XEM_TU}}}`, den: `{{ts.${TS_XEM_DEN}}}` } });
    return l;
  });
  return moi ? { ...moi, thamSo: [...k.thamSo, ...thamSoXem(loai)] } : k;
}

// ---------------------------------------------------------------- MỤC 5: lướt theo phút / số mục ngẫu nhiên / thích ngẫu nhiên ----------------------------------------------------------------
const TS_PHUT: KhoiThamSo[] = [
  { ten: "tu_phut", kieu: "so", anKhiRong: true, min: 1, max: 30, moTa: "lướt NGẪU NHIÊN ít nhất bao nhiêu PHÚT (điền cả hai ô thì lướt theo thời gian thay cho số bài/video; tối đa 30 phút một lần)" },
  { ten: "den_phut", kieu: "so", anKhiRong: true, min: 1, max: 30, moTa: "lướt nhiều nhất bao nhiêu PHÚT (không nhỏ hơn số phút ít nhất)" },
];
const TS_THICH = (donVi: string, coDen: boolean): KhoiThamSo[] => [
  { ten: "thich_tu", kieu: "so", anKhiRong: true, min: 0, max: 10, moTa: `thích NGẪU NHIÊN ít nhất bao nhiêu ${donVi} khi lướt${coDen ? " (điền cùng ô nhiều nhất — thay tỉ lệ thích)" : " (nhiều nhất = ô số thích tối đa)"}` },
  ...(coDen ? [{ ten: "thich_den", kieu: "so" as const, anKhiRong: true, min: 0, max: 10, moTa: `thích nhiều nhất bao nhiêu ${donVi} khi lướt (không nhỏ hơn số ít nhất)` }] : []),
];
/** Bảng: mạng/khối lướt → bước vòng lặp + các tính năng gắn. */
const LUOT_THEO_KHOI: Readonly<Record<string, { vong: string; soTu?: boolean; phut?: boolean; layLai?: string; thich?: boolean; moTab?: { buoc: string; url: string } }>> = {
  "tiktok/luot_de_xuat": { vong: "luot_de_xuat_vong", soTu: true, phut: true },
  "youtube/luot_shorts": { vong: "luot_shorts_vong", soTu: true, phut: true },
  "tiktok/luot_video": { vong: "luot_xem_video", thich: true },
  "youtube/luot_video": { vong: "luot_xem_video", thich: true },
  "x/luot_bang_tin": { vong: "doc_bang_tin", phut: true, layLai: "lay_bang_tin", thich: true, moTab: { buoc: "lay_bang_tin", url: "{{goc}}home" } },
};
export function themLuot(ma: string, k: KhoiMau): KhoiMau {
  if (k.thamSo.some((t) => t.ten === "tu_phut" || t.ten === "thich_tu")) return k;
  // Facebook Lướt bảng tin: cấu hình nằm trong learned[luot_bang_tin].luot → gộp khoá vào ĐÚNG đối tượng luot (không thay cả luot)
  if (ma === "facebook" && k.ten === "luot_bang_tin") {
    const l = (k.learned.luot_bang_tin ?? {}) as Record<string, unknown>;
    const luot = { ...((l.luot as Record<string, unknown>) ?? {}), phut_tu: "{{ts.tu_phut}}", phut_den: "{{ts.den_phut}}", so_thich_tu: "{{ts.thich_tu}}" };
    return { ...k, learned: { ...k.learned, luot_bang_tin: { ...l, luot } }, thamSo: [...k.thamSo, ...TS_PHUT, ...TS_THICH("bài", false)] };
  }
  const c = LUOT_THEO_KHOI[`${ma}/${k.ten}`];
  if (!c) return k;
  const b = quetBuocYaml(k.yamlSteps).find((x) => x.id === c.vong);
  if (!b) throw new Error(`khối '${k.ten}' không có bước '${c.vong}' để gắn ô lướt`);
  const them: Record<string, unknown> = {};
  const ts: KhoiThamSo[] = [];
  if (c.soTu) { them.so_muc = { tu: "{{ts.so_tu}}", den: "{{ts.so_video}}" }; ts.push({ ten: "so_tu", kieu: "so", anKhiRong: true, min: 1, max: 10, moTa: "số video ÍT NHẤT (ngẫu nhiên từ số này tới số video tối đa mỗi lần)" }); }
  if (c.phut) { them.lap_theo_gio = { tu: "{{ts.tu_phut}}", den: "{{ts.den_phut}}", ...(c.layLai ? { lay_lai: c.layLai } : {}) }; ts.push(...TS_PHUT); }
  if (c.thich) { them.chon_thich = { tu: "{{ts.thich_tu}}", den: "{{ts.thich_den}}" }; ts.push(...TS_THICH(ma === "x" ? "bài" : "video", true)); }
  let learned = ganHoc(k.learned, b.cha, b.id, them);
  if (c.moTab) {
    learned = ganHoc(learned, [], c.moTab.buoc, { mo_truoc: "{{ts.mo_danh_cho_ban}}" }); // lúc lắp: "co" → địa chỉ tab Dành cho bạn (sachTruong), khác → bỏ
    ts.push({ ten: "mo_danh_cho_ban", kieu: "chuoi", anKhiRong: true, macDinh: "khong", luaChon: ["khong", "co"], moTa: "co = mở tab “Dành cho bạn” (trang chủ) trước khi lướt; khong (mặc định) = lướt trang đang mở (kết quả tìm / bảng tin)" });
  }
  return { ...k, learned, thamSo: [...k.thamSo, ...ts] };
}
/** mo_truoc của X: ô mo_danh_cho_ban = "co" → địa chỉ trang chủ (tab Dành cho bạn); khác → bỏ. Gọi lúc lắp (trước locTuyChonBuoc). */
export const URL_MO_DANH_CHO_BAN = "{{goc}}home";

// ---------------------------------------------------------------- gắn cho cả bảng khối của một mạng ----------------------------------------------------------------
export function themTuyChonBuocChoMang(ma: string, ds: KhoiMau[]): KhoiMau[] {
  return ds.map((k) => themLuot(ma, themXemTruoc(ma, themNghiKhoang(themNhacSp(themToiDaNgay(k))))));
}

// ---------------------------------------------------------------- lúc LẮP: bỏ trường của ô người dùng không đặt ----------------------------------------------------------------
const KHOA_DOT_B = new Set(["han_ngay", "nhac_sp", "xem_truoc", "khoang_nghi", "lap_theo_gio", "so_muc", "chon_thich", "mo_truoc"]);
const rong = (v: unknown): boolean => v === undefined || v === null || (typeof v === "string" && v.trim() === "");
/** Giá trị đã thay của một trường đợt B → bản sạch; mọi phần rỗng (ô không đặt) → undefined (bỏ trường). */
function sachTruong(k: string, v: unknown): unknown {
  if (k === "mo_truoc") return v === "co" ? URL_MO_DANH_CHO_BAN : undefined;
  // số mục ngẫu nhiên: chỉ khi người dùng điền "ít nhất" (ô "đến" là số tối đa BẮT BUỘC sẵn có của khối — luôn có giá trị)
  if (k === "so_muc" && v && typeof v === "object" && rong((v as { tu?: unknown }).tu)) return undefined;
  if (k === "nhac_sp" && v && typeof v === "object") {
    const o = v as { ti_le?: unknown; bat_buoc?: unknown };
    const ra: Record<string, unknown> = {};
    if (!rong(o.ti_le)) ra.ti_le = o.ti_le;
    if (o.bat_buoc === "co") ra.bat_buoc = "co";
    return Object.keys(ra).length ? ra : undefined;
  }
  if (v && typeof v === "object" && !Array.isArray(v)) {
    const o = v as Record<string, unknown>;
    if ("tu" in o && "den" in o) {
      // chỉ điền MỘT ô → ô kia lấy theo (như chờ giữa các lần); trống cả hai → bỏ
      if (rong(o.tu) && rong(o.den)) return undefined;
      return { ...o, tu: rong(o.tu) ? (k === "so_muc" || k === "chon_thich" ? o.den : "0") : o.tu, den: rong(o.den) ? o.tu : o.den };
    }
    return v;
  }
  return rong(v) ? undefined : v;
}
/** Phần đã học SAU khi thay {{ts.x}}: bỏ các trường đợt B rỗng (kể cả ở bước con `con`, trong `luot`). Không sửa đầu vào. */
export function locTuyChonBuoc<T>(learned: T): T {
  const loc = (v: unknown, trongLuot = false): unknown => {
    if (Array.isArray(v)) return v.map((x) => loc(x));
    if (!v || typeof v !== "object") return v;
    const out: Record<string, unknown> = {};
    for (const [k, x] of Object.entries(v as Record<string, unknown>)) {
      if (KHOA_DOT_B.has(k)) { const s = sachTruong(k, x); if (s !== undefined) out[k] = s; continue; }
      if (trongLuot && (k === "phut_tu" || k === "phut_den" || k === "so_thich_tu")) { if (!rong(x)) out[k] = x; continue; }
      out[k] = loc(x, k === "luot");
    }
    return out;
  };
  return loc(learned) as T;
}

/** Tên mọi tham số khối do đợt B thêm (khoá ô trên sơ đồ) — cho trang / test nhận ra ô tuỳ chọn mới. */
export const TEN_THAM_SO_DOT_B: ReadonlySet<string> = new Set([TS_TOI_DA_NGAY, TS_TI_LE_NHAC, TS_BAT_BUOC_TEN, TS_XEM_TU, TS_XEM_DEN, "tu_phut", "den_phut", "so_tu", "thich_tu", "thich_den", "mo_danh_cho_ban"]);
